const indexItems = [
  { letter: 'A', items: ['暗夜追踪', '爱情公寓', '奥本海默', '暗战'], color: 'bg-primary-100 text-primary-700' },
  { letter: 'B', items: ['冰与火之歌', '白蛇传', '变形金刚', '暴裂无声'], color: 'bg-accent-100 text-accent-700' },
  { letter: 'C', items: ['长安诡事录', '初恋那件小事', '超时空同居'], color: 'bg-secondary-100 text-secondary-700' },
  { letter: 'D', items: ['大江大河', '盗梦空间', '动物世界', '毒液'], color: 'bg-primary-100 text-primary-700' },
  { letter: 'F', items: ['复仇者联盟', '芳华', '飞驰人生', '封神'], color: 'bg-accent-100 text-accent-700' },
  { letter: 'H', items: ['红海行动', '黑客帝国', '花木兰', '火影忍者'], color: 'bg-secondary-100 text-secondary-700' },
  { letter: 'J', items: ['寄生虫', '教父', '金刚川', '姜子牙'], color: 'bg-primary-100 text-primary-700' },
  { letter: 'N', items: ['哪吒之魔童降世', '你好李焕英', '怒火重案'], color: 'bg-accent-100 text-accent-700' },
  { letter: 'X', items: ['星河纪元', '笑傲江湖录', '悬崖之上', '小丑'], color: 'bg-secondary-100 text-secondary-700' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-1">
            影视索引
          </h2>
          <p className="text-sm text-foreground-500">按首字母快速查找你想看的内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexItems.map((group) => (
            <div
              key={group.letter}
              className="flex items-start gap-4 p-4 rounded-xl bg-background-100 border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer"
            >
              <span className={`w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg text-lg font-bold ${group.color}`}>
                {group.letter}
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap gap-1.5">
                  {group.items.map((name) => (
                    <span
                      key={name}
                      className="px-2.5 py-1 rounded-md bg-background-50 text-xs text-foreground-600 hover:text-primary-600 hover:bg-primary-50 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {name}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}